import { useMemo } from 'react'
import { useGetServicetypes } from '@/api/generated/service-type/service-type'
import type { ServiceTypeListItemAdminApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'

// Bridge: the generated contract doesn't yet expose Category. Remove this local
// extension once Orval regenerates with the field included.
type ServiceTypeWithCategory = ServiceTypeListItemAdminApiOutContract & {
  Category?: string | null
}

export function useMedicationCategories() {
  const { data } = useGetServicetypes()

  return useMemo(() => {
    const list = (data ?? []) as ServiceTypeWithCategory[]
    const all = list.map((s) => s.Category).filter((c): c is string => !!c)
    return Array.from(new Set(all)).sort((a, b) => a.localeCompare(b))
  }, [data])
}
